import { useEffect } from 'react';

import SettingsOptionsAndExtensions from '../settings-options-and-extensions';

import useStyles from './SettingsProfile.style';

function SettingsProfile({ titleBox, getSettings = () => {} }) {
  const componentClasses = useStyles();

  useEffect(() => {
    getSettings();
  }, [getSettings]);

  return (
    <>
      <div className={componentClasses.container}>
        <div className={componentClasses.titleStyles}>{titleBox}</div>
        <div className={componentClasses.root}>
          <SettingsOptionsAndExtensions />
        </div>
      </div>
    </>
  );
}

export default SettingsProfile;
